module.exports = __webpack_public_path__ + "static/mkamranhamid-b178c88f884a1e30aa570d345dae1208.jpg";